import React, { Component } from 'react';
import { parseString } from 'xml2js';
import { forEachObjIndexed,  head, pathOr } from 'ramda';
import { templates, getItem } from './XMLResumeTemplates';

import { notEmpty } from 'utils/ramdaAdditions';

const getFullName = (root) => root.fio ? head(root.fio) :
    `${head(pathOr('', ['first_name'], root))} ${head(pathOr('', ['middle_name'], root))} ${head(pathOr('', ['last_name'], root))}`;

export default class DocumentXMLResume extends Component {
    state = {
        resume: null
    }

    componentDidMount() {
        const { body } = this.props;

        parseString(body.replace(/&/g, '&amp;'), (err, { root }) => {
            if (!root) return;

            const resume = {
                fields: [],
                sections: [],
                photo: [],
                wait_status: [],
                wait_money: [],
                lastUpdate: [],
                root
            };

            forEachObjIndexed((value, key) => {
                const templateKey = templates[key];

                if (templateKey) {
                    if (templateKey.skip) {
                        return;
                    }
                    const targetProp = resume[templateKey.target];
                    const addProp = templateKey.addProp && root[templateKey.addProp];
                    targetProp.push(getItem(value, key, addProp));
                }
            }, root);

            this.setState({ resume });
        });
    }

    render() {
        if (!this.state.resume) {
            return null;
        }

        const { resume: { root, photo, wait_status, wait_money, last_update, fields, sections } } = this.state;

        return (
            <div className="xml-resume">
                <h1>{getFullName(root)}</h1>
                { notEmpty(photo) && head(photo) }
                <div className="xml-table">
                    <div className="panel-view">
                        { fields.map((item) => item) }
                    </div>
                </div>
                { notEmpty(wait_status) && head(wait_status) }
                { notEmpty(wait_money) && head(wait_money) }
                { sections.map((item) => item) }
                { notEmpty(last_update) && head(last_update) }
            </div>
        )
    }
}
